import type { HTMLAttributes } from "react";
import { cx } from "./cx";

/** Token-spaced, wrapping layout for groups of page controls. */
export function ControlBar({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx("pz-controlbar", className)} {...props} />;
}

/** Keeps related controls together while the parent bar owns sibling spacing. */
export function ControlGroup({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx("pz-controlbar__group", className)} {...props} />;
}
